import { define, Model, AttributesMixin } from "@type-r/models";
import { restfulIO } from 'api/endpoint';

export interface Currency extends AttributesMixin<typeof Currency> { }

@define
export class Currency extends Model {
  static endpoint = restfulIO('/api/v1/incash/cash-balance/currencies');

  static attributes = {    
    id: String,
    label: String
  }
}